<template>
	<v-row>
		<v-col>
			<v-row>
				<v-col>
					<v-alert
						v-if="Object.keys(submissionErrors).length > 0"
						type="error"
					>
						The following errors have been found:
						<p
							v-for="(error, key) in submissionErrors"
							:key="key"
						>
							<translate>{{ key }}</translate>: <translate>{{ error }}</translate>
						</p>
					</v-alert>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-stepper
						v-model="step"
						color="primary"
					>
						<v-stepper-header>
							<v-stepper-item
								:complete="step > 1"
								:value="1"
							>
								<translate>
									Device data
								</translate>
							</v-stepper-item>

							<v-divider />
							<v-stepper-item
								:complete="step > 2"
								:value="2"
							>
								<translate>
									Insurance select
								</translate>
							</v-stepper-item>
							<v-divider />
							<v-stepper-item
								:complete="step > 3"
								:value="3"
							>
								<translate>
									Customer Data
								</translate>
							</v-stepper-item>
							<v-divider />

							<v-stepper-item
								:complete="step > 4"
								:value="4"
							>
								<translate>
									Device data
								</translate>
							</v-stepper-item>
							<v-divider />

							<v-stepper-item
								:complete="step > 5"
								:value="5"
							>
								<translate>
									Complete
								</translate>
							</v-stepper-item>
						</v-stepper-header>
						<v-stepper-window>
							<v-stepper-window-item :value="1">
								<v-row>
									<v-col>
										<order-device-picker
											v-model:order-row="order.row"
											@update:order-row="order.row = $event"
											@update:domain="domain = $event"
											@update:next="step = 2"
										/>
									</v-col>
								</v-row>
							</v-stepper-window-item>
							<v-stepper-window-item :value="2">
								<v-row>
									<v-col>
										<order-insurance-select
											:device-id="order.row.device"
											:insurance-start-date="order.row.insuranceStartDate"
											:domain-id="domain.id"
											@update:product-version-id="(step = 3) && (order.row.productVersionId = $event)"
											@update:previous="step = 1"
										/>
									</v-col>
								</v-row>
							</v-stepper-window-item>
							<v-stepper-window-item :value="3">
								<order-customer-select
									:domain="domain"
									@update:previous="step = 2"
									@update:client="(step = 4) && (client = $event)"
									@update:document="clientDocument = $event"
								/>
							</v-stepper-window-item>
							<v-stepper-window-item :value="4">
								<order-device-data
									:order="order"
									:risk-level="client.riskLevel"
									:disable-send-data="disableSendData"
									:update:document-="orderDocument"
									@update:submit="sendData"
									@update:previous="step = 3"
									@update:risk-level="client.riskLevel = $event"
								/>
							</v-stepper-window-item>
							<v-stepper-window-item :value="5">
								<order-completion />
							</v-stepper-window-item>
						</v-stepper-window>
					</v-stepper>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import axios from 'axios';

export default {
	name: 'ResellerAdd',
	data () {
		return {
			step: 1,
			order: {
				reference: null,
				pointOfSaleId: null,
				sellerName: null,
				row: {
					ean: null,
					imei: null,
					serialNumber: null,
					phonePurchaseDate: null,
					device: null,
					purchasePrice: '',
					productVersionId: null,
					refurbishedDevice: false,
					insuranceStartDate: null,
				},
			},
			client: {
				email: '',
				name: {
					initials: null,
					infix: null,
					first: null,
					last: null
				},
				gender: null,
				dateBirth: null,
				telephonenumber: null,
				language: null,
				address: {
					street: null,
					number: null,
					numberSuffix: null,
					city: null,
					country: null,
					postalcode: null,
					administrativeArea: null,
				},
				bankaccount: {
					iban: null
				},
				isBusiness: false,
				business: {
					name: null,
					kvk: null,
				},
				riskLevel: false,
			},
			clientDocument: null,
			domain: null,
			orderDocument: null,
			insurance: null,
			insurances: [],
			errors: this.getInitialErrors,
			existingCustomer: null,
			submissionErrors: {
			},
			disableSendData: false,
		};
	},


	methods: {

		/**
		 * Send data to the backend to potentially accept the customer
		 *
		 * @returns {void}
		 */
		sendData () {
			/* eslint-disable camelcase */
			this.disableSendData = true;
			axios.post('/api/v0/resellers/orders/add', {
				client: {
					email: this.client.email,
					name: this.client.name,
					gender: this.client.gender,
					date_birth: this.client.dateBirth,
					telephonenumber: this.client.telephonenumber,
					language: this.client.language,
					address: {
						street: this.client.address.street,
						number: this.client.address.housenumber,
						number_suffix: this.client.address.housenumberSuffix,
						city: this.client.address.city,
						country: this.domain.country.code,
						postalcode: this.client.address.postalcode,
						administrative_area: this.client.address.administrativeArea,
						residential_area: this.client.address.residentialArea,
						floor: this.client.address.floor,
						house_name: this.client.address.houseName,
						door_code: this.client.address.doorCode,

					},
					bankaccount: {
						iban: this.client.bankaccount.iban
					},
					is_business: this.client.isBusiness,
					business: {
						name: this.client.business.name,
						kvk: this.client.business.kvk,
					},
					risk_level: this.client.riskLevel,
				},
				order: {
					reference: this.order.reference,
					pointofsale_id: this.order.pointOfSaleId,
					seller_name: this.order.sellerName,
					rows: {
						1: {
							phone: {
								ean: this.order.row.ean,
								imei: this.order.row.imei,
								serial_number: this.order.row.serialNumber,
								purchase_date: this.order.row.phonePurchaseDate,
								purchase_price_cent: this.order.row.purchasePrice * 100,
								device_id: this.order.row.device,

							},
							product_version_id: this.order.row.productVersionId,
							refurbished_device: this.order.row.refurbishedDevice,
							insurance_start_date: this.order.row.insuranceStartDate,
						}
					}
				},
				expects_existing_user: this.knownUser,
				client_document: this.clientDocument,
				order_document: this.orderDocument,
				reseller_portal: true
			})
				.then(() => {
					this.step = 5;
					this.submissionErrors = {
					};
				})
				.catch(({
					response
				}) => {
					this.submissionErrors = response.data.messages;
					this.disableSendData = false;
				});
		}
	},
};
</script>
